import {
  Badge,
  Button,
  Center,
  HStack,
  Icon,
  Image,
  Text,
  Tooltip,
  useToast,
  VStack,
  Wrap,
} from "@chakra-ui/react";
import { Clock, UsersThree } from "@phosphor-icons/react";
import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Container from "../components/Container";
import Footer from "../components/Footer";
import Nav from "../components/nav/Nav";
import ShareCourse from "../components/ShareCourse";
import ComponentSpinner from "../components/spinner/ComponentSpinner";
import { iconSize } from "../const/sizes";
import { Course } from "../const/types";
import useTrigger from "../globalState/useTrigger";
import formatDate from "../lib/formatDate";
import formatDuration from "../lib/formatDuration";
import formatNumber from "../lib/formatNumber";
import formatNumberShort from "../lib/formatNumberShort";
import cr from "../lib/request";

export default function DetailCourse() {
  const { courseId } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingJoin, setLoadingJoin] = useState<boolean>(false);
  const [data, setData] = useState<Course | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);

    const url = `api/course/${courseId}/showdetail`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [courseId]);

  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();

  const onJoin = () => {
    setLoadingJoin(true);
    const url = `api/course/joincourse`;
    const payload = {
      course_id: courseId,
    };

    cr.post(url, payload)
      .then((r) => {
        if (r.status === 201) {
          toast({
            title: r.data.message,
            description: r.data.data.nama_course,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: "Gagal bergabung di course",
          description: e?.response?.data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        if (e.response.status === 401) {
          const signinButton = document.querySelector(
            "#signinbutton"
          ) as HTMLButtonElement;
          if (signinButton) {
            signinButton.click();
          }
        }
      })
      .finally(() => {
        setLoadingJoin(false);
      });
  };

  return (
    <VStack align={"stretch"} gap={0} minH={"100vh"}>
      <Nav />
      {loading && <ComponentSpinner />}

      {!loading && data && (
        <Container mx={"auto"} py={8}>
          <Image
            w={"100%"}
            src={`${process.env.REACT_APP_MEDIA_BASE_URL}${data.image}`}
            objectFit={"cover"}
            aspectRatio={"16/9"}
            mb={4}
          />

          <VStack p={2} mb={4} gap={4} align={"stretch"}>
            <Badge w={"fit-content"} colorScheme="ap">
              {data?.theme?.theme_name}
            </Badge>

            <Text fontSize={24} fontWeight={700} lineHeight={1.4}>
              {data.nama_course}
            </Text>

            <Text opacity={0.5}>{data.description}</Text>

            <VStack align={"flex-start"}>
              <HStack>
                <Icon as={Clock} fontSize={iconSize} />
                <Text>{formatDuration(data.total_duration)}</Text>
              </HStack>

              <Tooltip label={`${formatNumber(data?.totalmembers)} mengukuti`}>
                <HStack>
                  <Icon as={UsersThree} fontSize={20} />
                  <Text noOfLines={1}>
                    {formatNumberShort(data?.totalmembers)}
                  </Text>
                </HStack>
              </Tooltip>

              <Text>{`Terakhir diperbarui ${formatDate(data.updated_at, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              })}`}</Text>

              <Text
                w={"100%"}
                fontSize={24}
                fontWeight={700}
                color={"p.500"}
                my={4}
                // textAlign={"right"}
              >
                {data.price && data.price !== 0
                  ? `Rp ${formatNumber(data.price)}`
                  : "Gratis"}
              </Text>

              <Wrap align={"center"}>
                <Button
                  colorScheme="ap"
                  className="clicky"
                  onClick={onJoin}
                  h={"50px"}
                  isLoading={loadingJoin}
                  px={8}
                >
                  Konfirmasi Bergabung
                </Button>

                <ShareCourse data={data} />
              </Wrap>
            </VStack>
          </VStack>

          <VStack align={"stretch"} gap={4} p={2}>
            <Text fontWeight={600} fontSize={18}>
              {`Kurikulum (${data.subs?.length})`}
            </Text>

            <Wrap spacing={2}>
              {data?.subs?.map((silabus, i) => (
                <Center
                  px={4}
                  py={2}
                  borderRadius={"full"}
                  border={"1px solid var(--p500)"}
                >
                  <Text fontSize={14}>{silabus.nama_sub_course}</Text>
                </Center>
              ))}
            </Wrap>
          </VStack>

          <VStack align={"stretch"} p={2}>
            <Text fontWeight={600} fontSize={18}>
              Manfaat
            </Text>

            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(data.benefit),
              }}
            />
          </VStack>
        </Container>
      )}

      <Footer />
    </VStack>
  );
}
